/* eslint-env browser */
// Libs
import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

// Components
import Text from '../../../base/Text';
import ValidateButton from '../ValidateButton';
import arrow from '../Assets/ico_back.svg';

// Styles
import Styles from './TicketInfoGrayCollapsable.styles';
import { PINK } from '../../../../constants/colors';

// Styled components
const GrayContainer = styled.div`${Styles.grayContainer}`;
const Label = styled(Text).attrs({ bold: true })`${Styles.labelInput}`; // prettier-ignore
const LabelLight = styled(Text).attrs({ bold: true })`${Styles.labelLight}`; // prettier-ignore
const ButtonContainer = styled.div`${Styles.buttonContainer}`;

/**
 * TicketInfoGrayCollapsable
 * @param {function} buttonAction - Action to execute on button press
 * @param {string} buttonText - Label to display button
 * @param {Object} data - Ticket data from localStorage
 * @param {Object} translations - Current i18n dictionary
 * @returns {JSX.Element}
 */
const TicketInfoGrayCollapsable = ({
  buttonAction, buttonText, data, translations
}) => {
  let collapsed = false;
  const isMobile = false;

  const { isTicketFlow, isParkingFlow } = data;

  let info = {};
  let parkingData = null;

  if (isTicketFlow) {
    const {
      origin, destination, noPassengers, flightDate, returnDate, price
    } = data;
    info = {
      origin, destination, noPassengers, flightDate, returnDate, price
    };
  }

  if (typeof window !== "undefined" && isParkingFlow) {
    parkingData = JSON.parse(window.localStorage.getItem('parking'));
    info = parkingData ? {
      start: parkingData.data.from.replace('T', ' @ ').substring(0, 18),
      end: parkingData.data.to.replace('T', ' @ ').substring(0, 18),
      lot: parkingData.data.lot[0].location_name,
      counterParking: parkingData.vehicles.length
    } : {};
  }

  // eslint-disable-next-line require-jsdoc
  const toggleCollapse = () => {
    collapsed = !collapsed;
  };

  /**
   * addAmPmLabel
   * @param {string} val - value to add label
   * @returns {string}
   */
  const addAmPmLabel = val => (+val.split('@')[1].split(':')[0] < 12 ? `${val} AM` : `${val} PM`);

  return  Object.keys(info).length > 0 && (
    <GrayContainer style={isMobile ? { display: 'flex', flexDirection: 'column' } : { gridTemplateColumns: `repeat(${collapsed ? 1 : 2}, 1fr)` }}>
      {collapsed && (
        <div
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center', position: 'relative'
          }}
          onClick={toggleCollapse}
          role="button"
          tabIndex={0}
        >
          <img
            alt=""
            width="10px"
            height="10px"
            style={{ position: 'absolute', left: 0, transform: [{ rotate: collapsed ? '270deg' : '90deg' }] }}
            src={arrow}
          />
          <Label color="#726C79">{`${translations.from} ${data.origin} ${translations.to} ${data.destination}`}</Label>
        </div>
      )}
      {!collapsed && isTicketFlow && (
        <div>
          <Label color="#726C79" style={{fontWeight: 'bold'}}>
            {`${translations.from} `}
            <span style={{color:PINK, textTransform:'uppercase'}}>{`${info.origin}`}</span>
            {` ${translations.to} `} 
            <span style={{color:PINK, textTransform:'uppercase'}}>{`${info.destination}`}</span>
          </Label>
          <LabelLight color="#726C79"> {`${info.noPassengers} ${info.noPassengers > 1 ? translations.shoppingLabels.passengers : translations.passenger}`} </LabelLight>
          <LabelLight color="#726C79" style={{ paddingBottom: '10px' }}>
            {`${info.flightDate} ${info.returnDate && `- ${info.returnDate}`}`}
          </LabelLight>
          <LabelLight color="#726C79" style={{ paddingBottom: '10px', fontWeight: 'bold' }}>
            {info.price.total}
          </LabelLight>

        </div>
      )}
      {!collapsed && isParkingFlow && (
        <div>
          <Label color="#726C79">{info.lot}</Label>
          <LabelLight color="#726C79">{`${translations.startFormParking}: ${addAmPmLabel(info.start)}`}</LabelLight>
          <LabelLight color="#726C79">{`${translations.endFormParking}: ${addAmPmLabel(info.end)}`}</LabelLight>
          <LabelLight color="#726C79">{`${translations.vehiclesNo}: ${info.counterParking}`}</LabelLight>
        </div>
      )}
      {!collapsed && (
        <ButtonContainer>
          <ValidateButton
            action={buttonAction}
            width="120px"
            message={buttonText}
          />
        </ButtonContainer>
      )}
    </GrayContainer>
  );
};

TicketInfoGrayCollapsable.propTypes = {
  buttonAction: PropTypes.func,
  buttonText: PropTypes.string,
  data: PropTypes.object,
  translations: PropTypes.object
};

export default TicketInfoGrayCollapsable;
